module.exports = __webpack_public_path__ + "static/media/class-3.ca938579.PNG";